import {Injectable} from '@angular/core';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import sdk from "@sp400/sdk";
import {lastValueFrom} from "rxjs";
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  cacheConfig: any;
  cacheName: string = 'fleet_api_cache';


  constructor(private dbService: NgxIndexedDBService) {

  }

  // Crea una chiave univoca combinando l'URL e i parametri
  private generateCacheKey(url: string, params: any): string {
    const serializedParams = JSON.stringify(params);
    return `${url}?params=${serializedParams}`;
  }

  // Controlla se esiste una cache per l'URL e i parametri
  async getFromCache(url: string, params: any): Promise<any> {
    const cacheKey = this.generateCacheKey(url, params);
    return this.dbService.getByIndex(this.cacheName,'url', cacheKey).toPromise();
  }

  async deleteItem(url: any, params: any): Promise<void> {
    this.dbService.deleteByKey(this.cacheName, this.generateCacheKey(url, params));
  }

  async clearCache(): Promise<boolean> {
    const $clearedDB = this.dbService.clear(this.cacheName);
    return await lastValueFrom($clearedDB);
  }

  // Salva la response in cache
  async saveToCache(url: string, params: any, response: any): Promise<void> {
    const cacheKey = this.generateCacheKey(url, params);
    const responseTime = moment().format('DD/MM/YYYY HH:mm:ss');
    const stringResponse = JSON.stringify(response)
    if (await this.getFromCache(url, params)) {
      await this.dbService.update(this.cacheName, {
        url: cacheKey,
        stringResponse,
        responseTime
      }).toPromise();
    } else {
      await this.dbService.add(this.cacheName, {
        url: cacheKey,
        stringResponse,
        responseTime
      }).toPromise();
    }
    console.log(`Response for ${url} with params cached successfully`);
  }

  // Esegue una richiesta HTTP con controllo cache
  async get(action: string, params: any = {}): Promise<any> {
    const cachedResponse = await this.getFromCache(action, params);
    if (this.cacheConfig['ACTIVE'] && cachedResponse && this.checkIfResponseIsOutdated(cachedResponse)) {
      console.log(`Cache hit for ${action} with params. Stored response:`, JSON.parse(cachedResponse.stringResponse));
      return JSON.parse(cachedResponse.stringResponse);
    } else {
      console.log(`Cache miss for ${action} with params`);
      // Effettua la richiesta HTTP se la cache è assente
      const response = await sdk.get(action, params);
      if (!response.errors) {
        await this.saveToCache(action, params, response);
      }
      return response;
    }
  }

  // Esegue una richiesta HTTP con controllo cache
  async set(action: string, params: any = {}): Promise<any> {
    const cachedResponse = await this.getFromCache(action, params);
    if (this.cacheConfig['ACTIVE'] && cachedResponse && this.checkIfResponseIsOutdated(cachedResponse)) {
      console.log(`Cache hit for ${action} with params. Stored response:`, JSON.parse(cachedResponse.stringResponse));
      return JSON.parse(cachedResponse.stringResponse);
    } else {
      console.log(`Cache miss for ${action} with params`);
      // Effettua la richiesta HTTP se la cache è assente
      const response = await sdk.set(action, params);
      if (!response.errors) {
        await this.saveToCache(action, params, response);
      }
      return response;
    }
  }

  checkIfResponseIsOutdated(response: any): boolean {
    console.log('CACHE => ', moment().format('DD/MM/YYYY HH:mm:ss'), moment(response.responseTime, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'));
    const difference = moment().diff(moment(response.responseTime, 'DD/MM/YYYY HH:mm:ss'), 's');
    console.log('CACHE => ', 'Difference in time:', Math.abs(difference), ' seconds');
    return difference < this.cacheConfig['TTL'];
  }

  setCacheConfig(config: any): void {
    this.cacheConfig = config;
  }
}
